/*# sourceMappingURL=location-details.component-I74I2IVD.css.map */
